import styled from 'styled-components';

export const CellExpander = styled.td`
  padding: 0;
  border: none;
`;

export const BtnExpander = styled.button<{
  width: string;
  minWidth: string;
  expanderBackgroundColor?: string;
  expandableRows: boolean;
  isRowExpandable: boolean;
}>`
  display: flex;
  align-items: center;
  visibility: ${({ expandableRows, isRowExpandable }) =>
    expandableRows && !isRowExpandable ? 'hidden' : 'visible'};
  justify-content: center;
  width: ${({ width }) => width};
  min-width: ${({ minWidth }) => minWidth};
  background-color: ${({ expanderBackgroundColor }) =>
    expanderBackgroundColor ?? 'transparent'};
  cursor: pointer;
  padding: 0.25rem;
  height: 100%;
`;
